import { withInstall } from '@element-plus/utils/with-install'
import Avatar from './src/avatar.vue'

export const ElAvatar = withInstall(Avatar)
export default ElAvatar

export * from './src/avatar'
